import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Text } from "shared/components/Text";
import { Button } from "shared/components/Button";
import { RankingBar } from "shared/components/RankingBar";
import { RankingEntry } from "shared/components/RankingEntry";
import { Spinner } from "shared/components/Spinner";
import sectionSeparator from "assets/images/section-separator.png";
import titleGlow from "assets/images/title-glow.png";
import { prettifyMiliseconds } from "shared/utils";
import { databaseStore } from "store/database";
import {
  getResultsData,
  getTeamsData,
  getIsLoading,
} from "store/database/selectors";
import { setResultsData } from "store/database/actions";

import css from "./styles.module.scss";

export const RankingSection = ({
  passedRef,
  mainPageGameId,
  mainPageEntryCount,
  city,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const mainPageGameResults = databaseStore.useState(
    getResultsData(mainPageGameId),
  );
  const teamsData = databaseStore.useState(getTeamsData);
  const isLoading = databaseStore.useState(getIsLoading);

  return (
    <div className={css.RankingSection} ref={passedRef}>
      <Text type="white" className={css.title} bold secondaryFamily>
        {t("rankingSection.title")}
      </Text>
      <Text type="white" className={css.subTitle} bold secondaryFamily>
        {t("rankingSection.shownGame")}
      </Text>
      <div className={css.rankingContent}>
        <RankingBar />
        {!isLoading && mainPageGameResults && Object.keys(teamsData).length ? (
          mainPageGameResults
            .filter((el) => teamsData[el.team_id].team_name)
            .slice(0, mainPageEntryCount)
            .map((el, i) => (
              <RankingEntry
                key={i}
                place={i + 1}
                teamName={teamsData[el.team_id].team_name}
                time={prettifyMiliseconds(el.miliseconds)}
                image={teamsData[el.team_id].image_url}
                lighter={i % 2}
                isInTop={i + 1 <= 3}
              />
            ))
        ) : (
          <Spinner type="small" />
        )}
      </div>
      <Button
        text={t("rankingSection.checkRankings")}
        onClick={() => {
          setResultsData(mainPageGameId, null);
          navigate(`/${city}/ranking`);
        }}
      />
    </div>
  );
};
